export const CUSTOM_MODAL_KEY = "modal"
